export default __webpack_public_path__ + "static/scrolled-logo-c65b0a1b66217d8f75137c339b6f7715.svg";